<script setup lang="ts">
  import type { SectionLine } from '@/stores/type/sectionLine.type'
  import { storeToRefs } from 'pinia'
  import type { SectionSelectionPolygon } from '@/stores/type/selectionPolygon.type'
  import type { GroundInvestigationPoint } from '@/stores/type/giPoint.type'
  import { findSelectionGIPointsIDs } from '@/utils/map'

  const sectionLinesStore = useSectionLinesStore()
  const selectionPolygonsStore = useSelectionPolygonsStores()
  const giPointsStore = useGIPointsStore()
  const sectionLinesGIPointsStore = useSectionLinesGIPointsStore()

  const { selectedItems: selectedSectionLines } = storeToRefs(sectionLinesStore)

  const { reselectSectionLinesDialog, writeLoading } = storeToRefs(sectionLinesGIPointsStore)
  const { items: giPoints } = storeToRefs(giPointsStore)
  const { polygonsBySectionLineId } = storeToRefs(selectionPolygonsStore)

  const addSelectionByPolygons = async (
    sectionLine: SectionLine,
    polygons: SectionSelectionPolygon[],
    giPointsArr: GroundInvestigationPoint[]
  ) => {
    const selectedGIPointsIDs = findSelectionGIPointsIDs(polygons, giPointsArr)
    if (selectedGIPointsIDs.length > 0) {
      await sectionLinesGIPointsStore.addGIPointsToSectionLine(selectedGIPointsIDs, sectionLine.id)
    }
  }
  const onReselectButtonClicked = (sectionLines: SectionLine[]) => {
    sectionLines.forEach(async (sectionLine: SectionLine) => {
      await addSelectionByPolygons(
        sectionLine,
        polygonsBySectionLineId.value(sectionLine.id),
        giPoints.value
      )
    })
    sectionLinesGIPointsStore.toggleReselectSectionLinesDialog()
  }
</script>

<template>
  <v-dialog width="450" v-model="reselectSectionLinesDialog">
    <v-card class="pa-3 pt-6">
      <v-card-title> Confirm Reselection</v-card-title>
      <v-card-text>
        Are you sure you want to reselect the GI points for the selected section lines? It will
        <strong>delete all existing GI Points selection and replace them with the new ones.</strong>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          variant="text"
          @click="sectionLinesGIPointsStore.toggleReselectSectionLinesDialog()"
          >Cancel
        </v-btn>
        <v-btn
          :loading="writeLoading"
          color="primary"
          variant="text"
          @click="onReselectButtonClicked(selectedSectionLines)"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
